export class FindDashboardChartsError {
  public static readonly type =
    '[Project/Dashboard/List] FindDashboardChartsError';
  constructor(public readonly error: Error) {}
}
